import * as React from 'react';
import { useMatch, useLocation } from 'react-router-dom';
import { pageNavsStore } from '@shared/store/navs';
import { ManagementContextProvider } from './context';
import ManagementList from './ManagementList';
import Editing from '../Editing';
import * as Styles from './styled';
import type { ResizablePanelRef } from '@shared/components/ResizablePanel';

const patchNav = pageNavsStore.getState().patch;

const Management = () => {
  const { pathname, search } = useLocation();
  const isMatchIndex = useMatch({
    path: '/management',
    end: true,
  });
  const resizablePanelRef = React.useRef<ResizablePanelRef>(null);
  const contextValue = React.useMemo(() => {
    return {
      setEditingPanelOpen: (open: boolean) => {
        resizablePanelRef.current?.setCollapsed(!open);
      },
    };
  }, []);

  React.useLayoutEffect(() => {
    patchNav('management', {
      path: pathname,
      search,
    });
  }, [pathname, search]);

  return (
    <Styles.Container>
      <Styles.Header>All Assets</Styles.Header>
      <Styles.Content
        ref={resizablePanelRef}
        minSize={550}
        left={!isMatchIndex ? <Editing /> : null}
        right={
          <ManagementContextProvider value={contextValue}>
            <ManagementList />
          </ManagementContextProvider>
        }
        styles={{
          left: { backgroundColor: '#fff' },
          right: { display: 'flex', flexDirection: 'column' },
        }}
      />
    </Styles.Container>
  );
};

export const ManagementPage = React.memo(Management);
